import { useCallback } from 'react';

const KEY = 'fly_recently_visited_v1';
const MAX = 5;

/**
 * Hook to track and retrieve recently visited airports, routes, blog posts.
 * Items shape: { type: 'airport'|'route'|'blog', href, label, sublabel? }
 */
export function useRecentlyVisited() {
  const add = useCallback((item) => {
    try {
      const existing = JSON.parse(localStorage.getItem(KEY) || '[]');
      const deduped  = existing.filter(e => e.href !== item.href);
      localStorage.setItem(KEY, JSON.stringify([item, ...deduped].slice(0, MAX)));
    } catch {}
  }, []);

  const get = useCallback(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch { return []; }
  }, []);

  return { add, get };
}
